import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { TournamentJoinTeam } from '../models/tournament-join-team';
import { map } from 'rxjs/operators';
import { TeamUser } from '../models/team-user';
import { TournamentTeamUserInvite } from '../models/tournament-team-user-invite';
import { TournamentInvite } from '../models/tournament-invite';
import { ConfigService } from '../services/config.service';
import { TournamentJoin1x1Data } from '../models/tournament-join1x1-data';

export enum TournamentJoin1x1Status {
  not_sent = 1,
  invite_sent,
  in_tournament,
  not_valid,
}

@Injectable({providedIn: 'root'})
export class TournamentJoinApi {
  constructor(
    private httpClient: HttpClient,
    private configService: ConfigService,
  ) {
  }

  async getTeamsForJoin(tournamentId: number): Promise<TournamentJoinTeam[]> {
    return this.httpClient.get(`${this.configService.get('apiUrl')}/api/v1/tournament/${tournamentId}/teams_for_join/`).pipe(
      map(response => TournamentJoinTeam.toFront(response))
    ).toPromise();
  }

  async getTeamUsers(teamId: number): Promise<TeamUser[]> {
    return this.httpClient
      .get(`${this.configService.get('apiUrl')}/api/v1/team/${teamId}/users/`)
      .pipe(
        map(data => TeamUser.toFront(data))
      ).toPromise();
  }

  async joinTournament(tournamentId: number, teamId: number, invites: TournamentTeamUserInvite[]): Promise<TournamentInvite> {
    const body = {
      team: {id: teamId},
      user_invites: TournamentTeamUserInvite.toBack(invites)
    };
    return this.httpClient.post(`${this.configService.get('apiUrl')}/api/v1/tournament/${tournamentId}/join/`, body)
      .pipe(map(data => TournamentInvite.toFront(data)))
      .toPromise();
  }

  async join1x1Tournament(tournamentId: number, additionalData: TournamentJoin1x1Data): Promise<TournamentInvite> {
    return this.httpClient.post(
      `${this.configService.get('apiUrl')}/api/v1/tournament/${tournamentId}/join_1x1/`,
      TournamentJoin1x1Data.toBack(additionalData)
    )
      .pipe(map(data => TournamentInvite.toFront(data)))
      .toPromise();
  }

  async join1x1TournamentStatus(tournamentId: number): Promise<TournamentJoin1x1Status> {
    return this.httpClient.get(`${this.configService.get('apiUrl')}/api/v1/tournament/${tournamentId}/join_1x1_status/`)
      .pipe(map((data: { status: string }) => TournamentJoin1x1Status[data.status]))
      .toPromise();
  }
}
